import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { useTrackEvent } from '../../segment/segment';
import { EventTypeEnum, TrackParams } from '../../segment/types';
import { roomAtom } from '../../video-sdk';
import { isInSessionWithSelectedClientAtom } from '../state';

type TabViewExtraProperties = Partial<
  Pick<TrackParams, 'hasCompletedMeasureResponses' | 'hasMeasureBundles' | 'bundleCompletionState'>
>;

export const useSendClientInfoTabViewTrackingEvent = (
  patientShortId: string,
  event: EventTypeEnum,
  extraProperties: TabViewExtraProperties = {},
  isReady = true,
) => {
  const isInSession = !!useAtomValue(roomAtom);
  const isInSessionWithSelectedClient = useAtomValue(isInSessionWithSelectedClientAtom);

  const { userViewed } = useTrackEvent();
  const hasTrackedView = useRef(false);

  useEffect(
    function trackUserViewsByInSessionStatus() {
      if (!isReady || hasTrackedView.current) return;

      userViewed(event, {
        inSession: isInSession,
        patientShortId,
        isViewingUpcomingClient: !isInSessionWithSelectedClient,
        ...extraProperties,
      });
      hasTrackedView.current = true;
    },
    // Fire once per mount when data is ready; do not resend if inSession or patientShortId changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [event, isReady],
  );
};
